// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3LlrX","ranges":"BmiRanges_ranges__3iaSm"};